import {
  Component,
  EventEmitter,
  Injector,
  Input,
  OnInit,
  Output
} from "@angular/core";
import { UntypedFormControl, Validators } from "@angular/forms";
import { Observable, of } from "rxjs";
import { debounceTime, map, startWith, switchMap, tap } from "rxjs/operators";
import { MatOptionSelectionChange } from "@angular/material/core";
import { GenericComponent } from "../../components/generic.component";
import { BlockService } from "src/app/core/services/block.service";
import { LoadingDrivebService } from "@shared/components/loading-driveb/loading-driveb.service";
import { BlockSimplifiedDTO } from "@shared/models/block-dto";

@Component({
    selector: "app-smartfleet-block-auto-complete",
    templateUrl: "./block-auto-complete.component.html",
    styleUrls: ["./block-auto-complete.component.scss"],
    standalone: false
})
export class BlockAutoCompleteComponent
  extends GenericComponent
  implements OnInit
{
  loading = false;
  block = new UntypedFormControl();
  searchForm = this.fb.group({
    name: this.block
  });
  wasChangedByUser = false;

  blocks$: Observable<BlockSimplifiedDTO[]>;

  @Input() title = "";
  @Input() page = "";
  @Input() requiredText = "";
  @Input() clientId: number;
  @Input() set required(value: boolean) {
    if (value && !this.disabled) {
      this.searchForm.controls.name.setValidators([
        Validators.required,
        Validators.minLength(12)
      ]);
    }
  }
  @Input() set disabled(value: boolean) {
    if (value) {
      this.searchForm.disable();
    } else {
      this.searchForm.enable();
    }
  }
  @Output() onChange: any = new EventEmitter<BlockSimplifiedDTO>();

  constructor(
    private blockService: BlockService,
    injector: Injector,
    private loadingDrivebService: LoadingDrivebService
  ) {
    super(injector);
  }

  ngOnInit(): void {
    this.searchForm.valueChanges.subscribe((r) => {
      this.wasChangedByUser = this.searchForm.get("name").dirty;
    });

    if (this.page != "") {
      let key;
      switch (this.page) {
        case "dashboard":
          key = "ds-block";
          break;
        case "fleet-admin":
          key = "fa-block";
          break;
        default:
          break;
      }
      //e coleta o filtro correspondente, se houver
      if (
        localStorage.getItem(key) != null &&
        localStorage.getItem(key) != ""
      ) {
        const block = JSON.parse(localStorage.getItem(key));
        this.searchForm.controls.name.setValue(block["tag"]);
      }
    } else {
      this.clean();
    }
    this.blocks$ = this.block.valueChanges.pipe(
      startWith(""),
      debounceTime(200),
      tap(
        () => (
          (this.loading = true), this.loadingDrivebService.setAutoMode(false)
        )
      ),
      switchMap((value: string) => {
        if (value) {
          return this.blockService.autocompleteServiceBlock(
            value,
            this.clientId
          );
        } else {
          this.onChange.emit({} as BlockSimplifiedDTO);
          return of([]) as Observable<BlockSimplifiedDTO[]>;
        }
      }),
      map((result) => {
        this.loading = false;
        this.loadingDrivebService.setAutoMode(true);
        return result;
      })
    );
  }

  handleBlockChange(
    event: MatOptionSelectionChange,
    block: BlockSimplifiedDTO
  ): void {
    if (event.isUserInput === true) {
      this.onChange.emit(block);
    }
  }

  clean(): void {
    this.searchForm.reset();
    this.wasChangedByUser = true;
  }
}
